import CustomImageUpload from "../../component/CustomImageUpload";

export const GALLERY_BATCH_SIZE = 7;

export default function GalleryForm({
  formId,
  categories,
  categoryId,
  setCategoryId,
  status,
  setStatus,
  images,
  previews,
  onImageChange,
  onAddBatch,
  onRemoveBatch,
  onSubmit,
  saving,
}) {
  const allSlotsFilled = images.length > 0 && images.every(Boolean);
  const batches = Array.from(
    { length: images.length / GALLERY_BATCH_SIZE },
    (_, batchIndex) => images.slice(
      batchIndex * GALLERY_BATCH_SIZE,
      (batchIndex + 1) * GALLERY_BATCH_SIZE
    )
  );

  return (
    <form id={formId} onSubmit={onSubmit}>
      <div className="add-content-wrap">
        <div className="row">
          <div className="col-lg-6">
            <div className="add-page-inputs">
              <div className="label-wrap-add">
                <label>Gallery Category<small>*</small></label>
              </div>
              <select
                className="form-control"
                value={categoryId}
                onChange={(event) => setCategoryId(event.target.value)}
                disabled={saving}
              >
                <option value="">Select Gallery Category</option>
                {categories.map((category) => (
                  <option value={category._id} key={category._id}>{category.name}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="add-page-inputs">
              <div className="label-wrap-add"><label>Status</label></div>
              <select
                className="form-control"
                value={status}
                onChange={(event) => setStatus(event.target.value)}
                disabled={saving}
              >
                <option value="0">Enabled</option>
                <option value="1">Disabled</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {batches.map((batch, batchIndex) => (
        <div className="add-content-wrap" key={batchIndex}>
          <div className="row">
            <div className="col-lg-12">
              <div className="d-flex justify-content-between align-items-center">
                <h4>Image Set {batchIndex + 1}</h4>
                {batches.length > 1 && (
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => onRemoveBatch(batchIndex)}
                    disabled={saving}
                  >
                    Remove Set
                  </button>
                )}
              </div>
              <p>Upload all 7 images in this set.</p>
            </div>
            {batch.map((image, slotIndex) => {
              const index = batchIndex * GALLERY_BATCH_SIZE + slotIndex;
              return (
                <div className="col-lg-4 mb-4" key={index}>
                  <div className="add-page-inputs input-add-image">
                    <div className="label-wrap-add">
                      <label>Image {slotIndex + 1}<small>*</small></label>
                    </div>
                    <CustomImageUpload
                      name={`image_${index}`}
                      acceptedFormats={[".webp"]}
                      onImageChange={(event) => onImageChange(index, event)}
                      imagePreview={previews[index]}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}

      {allSlotsFilled && (
        <button
          type="button"
          className="addmore-images-client w-100 mb-4"
          onClick={onAddBatch}
          disabled={saving}
        >
          Add More (Create Set {batches.length + 1}) <span></span>
        </button>
      )}

      <div className="alert alert-info">
        Images are managed in complete sets of 7. Current total: {images.length} images ({batches.length} set{batches.length === 1 ? "" : "s"}).
      </div>
    </form>
  );
}
